import React from "react";
import axios from "axios";
import SectionTitle from "@modules/study/common/section_title";
import { LayoutMain } from "@unisearch/theme/layout";

const Events = () => {
  return (
    <LayoutMain
      title="Events"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/events`}
    >
      <div className="container" style={{ minHeight: "100vh" }}>
        <div style={{ marginTop: 60 }}>
          <SectionTitle shadow_text="Events" title="Coming Soon"></SectionTitle>
        </div>
      </div>
    </LayoutMain>
  );
};

export default Events;
